const tabs = {
  roulette: [],
  nuevo: [],
  popular: [],
  xMas: [],
};

const popularAmusnetIdsDesktop = [
  // desktop
  '20364', // Shining crown
  '20003', // 10 Power Hot
  '20029', // 20 Golden coins
  '20013', // 100 Golden coins
  '20281', // Secrets of sherwood
  '20174', // Extra crown
];

export const liveCasinoGames = [
  '51', // European Roulette
  '20328', // Dynamic European Roulette
  // European Roulette (Belgium) -
  // Dynamic European Roulette (Belgium) -
  '20331', // Onyx Auto Roulette
  '20329', // Dynamic Roulette 120x (Entertainer)
  '20333', // Vegas Roulette 500x (Entertainer)
  '20011', // Live Altın Rulet (Dealer)
  '20330', // Live European Roulette (Dealer)
  '20332', // Live Speed Roulette (Dealer)
  // Live Roulette - Bulgarian (Dealer) -
  '20335', // Live Roulette - Russian (Dealer)
  '20359', // Speed Baccarat (Dealer)
  '20360', // "Showtime Roulette 500x"
  '20362', // Extra Crown Deluxe LIVE
  '20373', // Football Thrill
  '20126', // Burning Keno
  '20289', // Superb Keno
  '20212', // Hot Keno
];

function getTab(slotName, slotId) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );

  if (popularAmusnetIdsDesktop.includes(slotId)) {
    return [...trueTab, 'popular'];
  }

  return trueTab;
}

export { getTab };
